<template>
  <qx-card title="常跑线路" class="detail">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
        >
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <!-- <section slot-scope="scope"></section> -->
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total || 0"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  queryVehicleOftenRunOrderInfo,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    vehicleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      searchBoxData: {
        vehicleCode: this.$route.query.id,
        plateNumber: '',
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {
            prop: 'sourceRegionName',
            label: '起始城市',
          },
          {
            prop: 'desRegionName',
            label: '目的城市',
          },
          {
            prop: 'orderNum',
            label: '订单数',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryVehicleOftenRunOrderInfo,
    setVehicleInfo (vehicleInfo) {
      this.searchBoxData.plateNumber = vehicleInfo.plateNumber;
    },
  },
};
</script>

<style>
</style>
